const theme = {
  colors: {
    white: "#FFFFFF",
    whiteSecondary: "#f2f2f2",
    blue: "#012d5c",
    blueSecondary: "#07b8fb",
    blueThird: "#002449",
    black: "#0C0C0C",
    gray: "#747576",
    lightgray: "#f6f6f6",
    graySecondary: "#cbcccc",
    grayThird: "#c0c2c4",
    grayFour: "#383838",
    green: "#13a841",
    lineBlue: "#00a2e0",
    yellow: "#f29500",
  },

  border: {
    radius: {
      xsmall: "0.5rem",
      small: "1.0rem",
      medium: "1.5rem",
      large: "2rem",
      xlarge: "2.5rem",
    },
  },

  font: {
    sizes: {
      xsmall: "1.2rem",
      small: "1.4rem",
      medium: "1.5rem",
      large: "1.6rem",
      xlarge: "2rem",
      xxlarge: "2.2rem",
      xxxlarge: "2.4rem",
      extraLarge: "2.6rem",
      xextraLarge: "2.8rem",
      xxextraLarge: "3.2rem",
      xxxextraLarge: "3.6rem",
      xxxxextraLarge: "4.2rem",
      extrabiglarge: "4.6rem",
      xextrabiglarge: "5.0rem",
    },
  },

  spacings: {
    xxsmall: "0.8rem",
    xsmall: "1.6rem",
    small: "2.4rem",
    xmedium: "2.8rem",
    medium: "3.2rem",
    large: "4.4rem",
    xlarge: "4.8rem",
    xxlarge: "5.6rem",
    xxxlarge: "9rem",
    extraLarge: "16rem",
  },
};

export default theme;
